import * as React from "react";

import { Apps28Filled, Apps28Regular } from "@fluentui/react-icons";

import { TeamAppConfig } from "Apps/TeamAppModel";

const GriffinControlPlaneApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "GriffinControlPlane" */ "./GriffinControlPlaneApp");
    return { default: namedExport.GriffinControlPlaneApp };
});

export const GriffinControlPlane: TeamAppConfig = {
    title: "Model B/B2 Deployment Management",
    regularIcon: Apps28Regular,
    filledIcon: Apps28Filled,
    description:
        "Manage Griffin Model B/B2 service deployment actions, including marking builds as bad " +
        "to prevent further rollout and trigger rollback, reverting bad build status, freezing " +
        "or unfreezing deployments at specific rings, and submitting urgent deployment requests.",
    team: "GriffinControlPlane",
    publicId: "Exchange\\GriffinControlPlane",
    owner: "griffincponcall@microsoft.com",
    role: "*",
    tags: [],
    app: GriffinControlPlaneApp,
    path: "/GriffinControlPlane"
};
